var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddToView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1297_7082)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6001 6.00005C3.6001 5.33731 4.13736 4.80005 4.8001 4.80005H19.2001C19.8628 4.80005 20.4001 5.33731 20.4001 6.00005C20.4001 6.66279 19.8628 7.20005 19.2001 7.20005H4.8001C4.13736 7.20005 3.6001 6.66279 3.6001 6.00005Z",
    fill: "#718096"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6001 12C3.6001 11.3373 4.13736 10.8 4.8001 10.8H19.2001C19.8628 10.8 20.4001 11.3373 20.4001 12C20.4001 12.6628 19.8628 13.2 19.2001 13.2H4.8001C4.13736 13.2 3.6001 12.6628 3.6001 12Z",
    fill: "#718096"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6001 18C3.6001 17.3373 4.13736 16.8 4.8001 16.8H19.2001C19.8628 16.8 20.4001 17.3373 20.4001 18C20.4001 18.6628 19.8628 19.2 19.2001 19.2H4.8001C4.13736 19.2 3.6001 18.6628 3.6001 18Z",
    fill: "#718096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 5.5C25 9.08985 22.0899 12 18.5 12C14.9101 12 12 9.08985 12 5.5C12 1.91015 14.9101 -1 18.5 -1C22.0899 -1 25 1.91015 25 5.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 5.5C14 3.016 16.016 1 18.5 1C20.984 1 23 3.016 23 5.5C23 7.984 20.984 10 18.5 10C16.016 10 14 7.984 14 5.5ZM18.95 5.95H20.75V5.05H18.95V3.25H18.05V5.05H16.25V5.95H18.05V7.75H18.95V5.95Z",
    fill: "#718096"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1297_7082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToView);
export default __webpack_public_path__ + "static/media/add-to-view.0b3b7d06587a01a092a35b2808597fc3.svg";
export { ForwardRef as ReactComponent };